import { Field, Form, Formik } from "formik";
import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import * as Yup from "yup";
import menuBg from "../../assets/images/bg/menu/account.svg";
import img1 from "../../assets/images/contact/img1.jpg";
import img2 from "../../assets/images/contact/img2.jpg";
import img3 from "../../assets/images/contact/img3.jpg";
import img4 from "../../assets/images/contact/img4.jpg";
import FooterBottom from "../../components/footerBottom";
import TextInput from "../../components/formfields/InputField";
import SubmitLoader from "../../components/SubmitLoader";
// components
import Header from "../../components/header";
import MainMenu from "../../components/mainMenu";
// actions
import { contactUsAction } from "./actions";
import "./style.scss";
import { regex } from "../../utils/regex";
import { Button, Col, Row } from "react-bootstrap";

// changed regex [0-9] to \d
const contacts = [
  {
    id: 1,
    image: img1,
  },
  {
    id: 2,
    bg: "linear-gradient(94.46deg, #777DEF 30.99%, #A4ADFB 67.8%), #777DEF",
    text: "WE’RE.",
  },
  {
    id: 3,
    bg: "linear-gradient(94.46deg, #54A7D9 30.99%, #80C6F1 67.8%), #4989B7",
    text: "HERE.",
  },
  {
    id: 4,
    image: img2,
  },
  {
    id: 5,
    image: img3,
  },
  {
    id: 6,
    bg: "linear-gradient(94.46deg, #9BDCD5 30.99%, #7FD7F2 67.8%), #9BDCD5",
    text: "TO",
  },
  {
    id: 7,
    bg: "linear-gradient(94.46deg, #FFCA41 30.99%, #EEBA54 67.8%), #FFCA41",
    text: "HELP.",
  },
  {
    id: 8,
    image: img4,
  },
];

const validationSchema = Yup.object({
  phone: Yup.string()
    .required("phone can not be empty")
    .matches(/1?\d{10}((ext|x)\d{1,4})?/i, "provide a valid phone number"),
  first_name: Yup.string().required("First Name can not be empty"),
  last_name: Yup.string().required("Last Name can not be empty"),
  email: Yup.string()
    .required("email Can not be empty")
    .email("email must be a valid email address")
    .matches(regex.email, "email must be a valid email address"),
  message: Yup.string().required("message can not be empty"),
});

const ContactUs = (props) => {
  const [openMenu, setOpenMenu] = useState(false);

  const initialState = {
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  };
  const handleOpenMenu = () => {
    setOpenMenu(!openMenu);
  };
  const handleCloseMenuMenu = () => {
    setOpenMenu(false);
  };
  const handleSubmit = (values, actions) => {
    props.contactUsAction(values, actions);
  };
  return (
    <>
      <Helmet>
        <title>The Clarity Cooperative for Therapists - Contact Us</title>
        <meta name="title" content={"The Clarity Cooperative for Therapists - Contact Us"} />
        <meta
          name="description"
          content={
            "Got something on your mind? Let's talk it over! Reach out to the Clarity Cooperative team for a friendly chat and get the support you need as a therapist."
          }
        />
      </Helmet>

      <MainMenu closeMenu={handleCloseMenuMenu} title="NAVIGATE" bgImage={menuBg} className={openMenu ? "active" : ""} />
      <Header openMenu={handleOpenMenu} className="headerStyleBlack" blackLogo />
      <div className="contactArea">
        <div className="mainContainer">
          <div className="contactContainer">
            <div className="contactContent">
              <h1>Do you need to talk something over?</h1>
              <p>Let’s have a chat!</p>

              <Formik initialValues={initialState} onSubmit={handleSubmit} validationSchema={validationSchema}>
                {({ values, handleChange, handleBlur }) => {
                  return (
                    <Form className="usefulFeatureForm">
                      <div className="usefulFeatureFormBG">
                        <Row className="gy-3">
                          <Col md={6}>
                            <Field
                              label="First Name*"
                              id="first_name"
                              name="first_name"
                              component={TextInput}
                              value={values.first_name}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              placeholder="First Name"
                            />
                          </Col>
                          <Col md={6}>
                            <Field
                              label="Last Name*"
                              id="last_name"
                              name="last_name"
                              component={TextInput}
                              value={values.last_name}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              placeholder="Last Name"
                            />
                          </Col>
                          <Col xs={12}>
                            <Field
                              label="E-mail*"
                              id="email"
                              name="email"
                              component={TextInput}
                              value={values.email}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              placeholder="Email"
                            />
                          </Col>
                          <Col xs={12}>
                            <Field
                              label="Phone #"
                              id="phone"
                              name="phone"
                              component={TextInput}
                              value={values.phone}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              placeholder="(123) 456-7890"
                            />
                          </Col>
                          <Col xs={12}>
                            <Field
                              label="Message*"
                              id="message"
                              name="message"
                              component={TextInput}
                              value={values.message}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              placeholder="Message"
                            />
                          </Col>
                        </Row>
                      </div>

                      <Button className="mt-5" variant="primary" type="submit" disabled={props.meta.isLoading}>
                        {props.meta.isLoading ? (
                          <span className="d-flex">
                            Sending... <SubmitLoader />
                          </span>
                        ) : (
                          <>Send It</>
                        )}
                      </Button>
                    </Form>
                  );
                }}
              </Formik>
            </div>
            <ul className="contactInfoList">
              {contacts.map((item) => (
                <li key={item.id}>
                  {item.image && (
                    <div
                      style={{
                        background: `url(${item.image}) no-repeat center center / cover`,
                      }}
                      className="w-100 h-100"
                    ></div>
                  )}
                  {item.text && (
                    <div className="w-100 h-100 d-flex align-items-center justify-content-center" style={{ background: item.bg }}>
                      {item.text}
                    </div>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <FooterBottom />
    </>
  );
};

const mapStateToProps = (state) => ({
  meta: state.meta,
});

export default connect(mapStateToProps, { contactUsAction })(ContactUs);
